import Vue from 'vue'
import Router from 'vue-router'

const both = (name) => () => import(`@/views/${name}`);
Vue.use(Router);
var routes=[
	{
		path: '/',
		name: '首页',
		component: both("index"),
	},
	{
		path: '/news',
		name: '新闻动态',
		component: both("news"),
	},
	{
		path: '/news_details',
		name: '新闻详情',
		component: both("news_details"),
	},
	{
		path: '/brand',
		name: '品牌项目',
		component: both("brand"),
	},
	{
		path: '/award',
		name: '大奖赛',
		component: both("award"),
	},
	{
		path: '/education',
		name: '许钦松乡村美术教育奖',
		component: both("education"),
	},
	{
		path: '/product',
		name: '获奖作品',
		component: both("product"),
	},
	{
		path: '/info',
		name: '信息公开',
		component: both("info"),
	},
	{
		path: '/about_xqs',
		name: '关于许钦松',
		component: both("about_xqs"),
	},
	{
		path: '/about_us',
		name: '关于我们',
		component: both("about_us"),
	},
	{
		path: '/order',
		name: '报名',
		component: both("order"),
	},
	{
		path: '/award_type',
		name: '大奖赛1',
		component: both("award_type"),
	},
	{
		path: '/order_type',
		name: '报名1',
		component: both("order_type"),
	},
	{
		path: '/award/create',
		name: '许钦松创作奖',
		component: both("award/create"),
	},
	{
		path: '/award/education',
		name: '许钦松乡村美术教育奖',
		component: both("award/education"),
	},
	{
		path: '/award/creativity',
		name: '许钦松少儿创艺奖',
		component: both("award/creativity"),
	}
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js